
(function() {
  if(!window['SellerPanda'] || !window['SellerPanda']['Swatchify']){
    console.error('Swatchify error! Please contact support@sellerpanda.com')
  } else {
    window['SellerPanda']['Swatchify'].swatchify_SetSwatches({swatches: {"Color":{"Red":"c#E42D2D","Aqua":"c#13C1C1","Blue":"c#98E0F4","Gray":"c#808080","Green":"c#049A04","Natural":"c#9E9C9C","Pepper Red":"c#E02E2E","Apple Green":"c#4DCF11","Midnight Blue":"c#280E73"}}, specific: {}});
  }
}())
